import NavBar from "../general/navBar";
import { HashLink as Link } from "react-router-hash-link";

const Hero = () => {
  return (
    <section className="hero-section" id="hero">
      <container className="hero-container">
        <NavBar />
        <div className="hero-inner">
          <h1 className="hero-title">
            BIENVENUE CHEZ <span>LEXICREDIS</span>
          </h1>
          <p className="hero-paragraph">
            Un cabinet d’Avocats au service des Banques
          </p>
          <Link to="/#contact" className="btn-empty-white">
            Nous contacter
          </Link>
        </div>
      </container>
    </section>
  );
};

export default Hero;
